import { useFormik } from "formik";
import React, { useEffect } from "react";
import * as Yup from "yup";
import { CheckBox, TextareaWithLabel } from "../../../components/micro";

const CompanyAttractionsFunds = ({
  AttractionsData,
  setAttractionsSelectedArray,
  setAttractionsError,
  attractionsFundsVales,
  attractions_other,
}) => {
  const getInitialValues = (arr, attractionsFundsVales) => {
    let initial = {
      attractions_other: attractions_other ?? "",
    };

    // arr?.map((element) => {
    //   initial[element.id] = false;
    // });
    arr?.forEach((element) => {
      initial[element.id] = attractionsFundsVales?.some(
        (val) => val.id === element.id
      );
    });
    return initial;
  };

  // formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: getInitialValues(AttractionsData, attractionsFundsVales),
  });

  useEffect(() => {
    let trueFieldKeys = Object.keys(formik.values).filter(
      (key) => formik.values[key]
    );
    // remove attractions other form
    trueFieldKeys = trueFieldKeys.filter(function (item) {
      return item !== "attractions_other";
    });

    setAttractionsSelectedArray({
      attractionsSelectedArray: trueFieldKeys,
      attractions_other: formik.values.attractions_other,
    });
    setAttractionsError("");
  }, [formik.values]);
  return (
    <>
      {AttractionsData?.map((element) => {
        return (
          <CheckBox
            idFrom={element.slug}
            label={element?.title}
            name={element.id}
            value={formik.values[element.id]}
            checked={formik.values[element.id]}
            onChange={formik.handleChange}
            className={"sm:text-base text-sm"}
          />
        );
      })}
      {formik.values[1] && (
        <TextareaWithLabel
          idFromName={"attractions_other"}
          label={"Others"}
          className={"border"}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.attractions_other}
        />
      )}
    </>
  );
};

export default CompanyAttractionsFunds;
